<div class="otp-modal">
  <p class="otp-info">
    {{ 'verifying_phone.text_1' | translate }}.<br />
    {{ 'verifying_phone.text_2' | translate }}
  </p>

  @if (otpForm) {
    <form [formGroup]="otpForm" (ngSubmit)="onSubmit()" (keydown.enter)="onSubmit()" class="otp-form">
      <div class="otp-input">
        <app-input
          labelType="floating"
          [id]="'otp'"
          [inputType]="'otp'"
          [formControl]="otpForm.controls.otp"
          [invalid]="otpForm.controls.otp.invalid && !!otpForm.get('otp')?.touched"
          (focusout)="otpForm.controls.otp.markAsTouched()"
          aria-label="{{ 'verifying_phone.aria_otp' | translate }}"
        ></app-input>
      </div>

      <app-button [full]="true" type="submit">
        {{ 'verifying_phone.cta_confirm' | translate }}
      </app-button>

      <div class="otp-actions">
        <button
          type="button"
          class="link"
          [disabled]="resendCooldown > 0 || isSending"
          (click)="sendCode()"
        >
          @if (resendCooldown === 0) {
            <span>{{ 'verifying_phone.resend' | translate }}</span>
          }
          @if (resendCooldown > 0) {
            <span>
            {{ 'verifying_phone.resend_in' | translate:{ seconds: resendCooldown } }}
          </span>
          }
        </button>
      </div>
    </form>
  }
</div>
